import userService from 'services/userData';
import analyticsService from 'services/utils/analytics';

class MixpanelService {
    adUnitKeyToMixPanelLabel = {
        rewardedVideo: 'Rewarded Video',
        offerWall: 'Offerwall',
        interstitial: 'Interstitial',
        banner: 'Banner'
    };

    // eslint-disable-next-line class-methods-use-this
    extractParamFromRoute(route, param) {
        if (route.matched) {
            const matchedRoute = route.matched.find((record) => record.meta && record.meta[param]);
            return matchedRoute ? matchedRoute[param] : null;
        }
        return null;
    }

    async getGeneralMixPanelOptions(route) {
        const subCategory = this.extractParamFromRoute(route, 'subCategory');
        const section = this.extractParamFromRoute(route, 'section');
        const subSection = this.extractParamFromRoute(route, 'subSection');
        const mixPanelOptions = {};

        // subCategoryName
        mixPanelOptions['Sub Category'] = subCategory;

        // section
        mixPanelOptions.Section = section;
        if (subSection) {
            mixPanelOptions['Sub Section'] = subSection;
        }

        // Login As User
        // Get user data and check if the user is the actual user or "login as" by admin user
        const { actualUser, actualUserName } = await userService.getUserData();
        if (actualUser) {
            mixPanelOptions['Login As User'] = actualUserName || 'True';
        } else {
            mixPanelOptions['Login As User'] = 'False';
        }

        return mixPanelOptions;
    }

    trackEvent(category, eventName, route, additionalOptions = {}) {
        let options = this.getGeneralMixPanelOptions(route);
        options = { ...options, ...additionalOptions };
        analyticsService.track(category, eventName, options);
    }
}

export default new MixpanelService();
